export default ({
    onClick,
    onCancel
}) => {
    return (
        <div className="verification-page">
            <div className="verification-alert">
                <div className="icon">🔄</div>
                <div className="title">Verification in progress</div>
                <div className="text">We have received your request and are processing it. You will receive a notification of the result soon.</div>
            </div>

            <div className="verification-buttons" style={{position: "unset"}}>
                <div className="button" onClick={onCancel}>Okay, thanks!</div>
            </div>
        </div>  
    )
}